import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Rewards data
  rewards: [],

  // Commission tiers for selection
  commissionTiers: [
    { id: 'tier-1', name: 'Bronze Tier' },
    { id: 'tier-2', name: 'Silver Tier' },
    { id: 'tier-3', name: 'Gold Tier' },
    { id: 'tier-4', name: 'Platinum Tier' },
    { id: 'tier-5', name: 'Diamond Tier' },
  ],

  // UI state
  ui: {
    createRewardModalOpen: false,
    selectTierModalOpen: false,
    showToast: false,
    toastMessage: '',
  },

  // Temporary form state for Create Reward
  rewardForm: {
    eventType: null, // 'CROSS_SALES' | 'POST_FREQUENCY' | 'IS_ONBOARDED'
    eventConfig: {
      salesAmount: '',
      postCount: '',
      duration: '',
    },
    rewardType: null, // 'FLAT_BONUS' | 'COMMISSION_TIER'
    rewardConfig: {
      bonusAmount: '',
      tierId: null,
      tierName: '',
    },
    isTimeBound: false,
    endDate: null,
  }
};

const gamificationSlice = createSlice({
  name: 'gamification',
  initialState,
  reducers: {
    // Modal actions
    openCreateRewardModal: (state) => {
      state.ui.createRewardModalOpen = true;
      // Reset form when opening
      state.rewardForm = initialState.rewardForm;
    },
    closeCreateRewardModal: (state) => {
      state.ui.createRewardModalOpen = false;
      state.rewardForm = initialState.rewardForm;
    },
    openSelectTierModal: (state) => {
      state.ui.selectTierModalOpen = true;
    },
    closeSelectTierModal: (state) => {
      state.ui.selectTierModalOpen = false;
    },
    showToast: (state, action) => {
      state.ui.showToast = true;
      state.ui.toastMessage = action.payload;
    },
    hideToast: (state) => {
      state.ui.showToast = false;
      state.ui.toastMessage = '';
    },

    // Form actions
    updateRewardForm: (state, action) => {
      const { field, value } = action.payload;
      const fields = field.split('.');

      if (fields.length === 1) {
        state.rewardForm[field] = value;
      } else if (fields.length === 2) {
        state.rewardForm[fields[0]][fields[1]] = value;
      }
    },

    resetRewardForm: (state) => {
      state.rewardForm = initialState.rewardForm;
    },

    // Reward actions
    addReward: (state, action) => {
      const newReward = {
        id: Date.now().toString(),
        ...action.payload,
        createdAt: new Date().toISOString(),
      };
      state.rewards.push(newReward);
    },
  },
});

export const {
  openCreateRewardModal,
  closeCreateRewardModal,
  openSelectTierModal,
  closeSelectTierModal,
  showToast,
  hideToast,
  updateRewardForm,
  resetRewardForm,
  addReward,
} = gamificationSlice.actions;

// Selectors
export const selectCreateRewardModalOpen = (state) => state.gamification.ui.createRewardModalOpen;
export const selectSelectTierModalOpen = (state) => state.gamification.ui.selectTierModalOpen;
export const selectShowToast = (state) => state.gamification.ui.showToast;
export const selectToastMessage = (state) => state.gamification.ui.toastMessage;
export const selectRewards = (state) => state.gamification.rewards;
export const selectCommissionTiers = (state) => state.gamification.commissionTiers;
export const selectRewardForm = (state) => state.gamification.rewardForm;

export default gamificationSlice.reducer;
